/* eslint-disable react/button-has-type,react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import { ACTIONS } from '../../../constants/strings';

import styles from './index.styl';

const ReadMoreBtn = ({ intl: { formatMessage }, onClick, ...other }) => {
  const { showMore } = ACTIONS.program;
  const children = `${formatMessage(showMore)}...`;

  return <button styleName="root" {...{ onClick, children }} {...other} />;
};

ReadMoreBtn.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
};

export default injectIntl(
  CSSModules(ReadMoreBtn, styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/common/ReadMoreBtn/index.jsx